module.exports = __webpack_public_path__ + "static/elephant-1080-a0b30a4065b75a8e42d31ddb014c4573.jpg";